import { SLIDING_ANIMATION } from '../components/notifications/constants/animations';

export default (self) => {
  self.setValue('isOpen', false);
  setTimeout(() => {
    self.setValue('activeTab', null);
  }, SLIDING_ANIMATION.OUT.DURATION - 100); // give 100 milliseconds to manipulate state before animation ends
};
